import styled from 'styled-components';
import { Loading } from 'components/Loading';
import { Spacer } from '@ontruck/orc';

const StyledLoading = styled(Loading)``;

const StyledTitle = styled.h2``;

const StyledContainer = styled(Spacer)`
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}` : '')}
`;

const StyledContent = styled(Spacer)`
  border: 1px solid var(--greyMouse);
`;

export { StyledLoading, StyledTitle, StyledContent, StyledContainer };
